import { Injectable } from '@angular/core';
import { ImpersonationToken } from '@hq-core/models/impersonation-token';
import { ImpersonationTokenResource } from '@hq-core/resources/impersonation-token.resource';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

function decodeJwtPayload(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
}

@Injectable({
    providedIn: 'root'
})
export class AuthImpersonationService {
    constructor(
        private impersonationTokenResource: ImpersonationTokenResource
    ) {
    }

    getImpersonationToken(): string {
        const token = JSON.parse(localStorage.getItem('impersonationToken')) as ImpersonationToken;
        return token?.idToken || '';
    }

    isImpersonating(): boolean {
        const token = localStorage.getItem('impersonationToken');
        return token !== null && token !== '' && token !== undefined;
    }

    impersonate(userId: number): Observable<boolean> {
        return this.impersonationTokenResource.get(userId).pipe(
            map(token => {
                const stringifiedToken = JSON.stringify(token);
                localStorage.setItem('impersonationToken', stringifiedToken);
                return true;
            })
        );
    }

    clearImpersonationToken(): void {
        localStorage.removeItem('impersonationToken');
    }

    isAuthenticated(): boolean {
        const expiration = this.getExpiration();
        return Date.now() < expiration;
    }

    getExpiration(): number {
        const token = JSON.parse(localStorage.getItem('impersonationToken')) as ImpersonationToken;
        if (!token?.idToken) {
            return 0;
        }
        const payload = decodeJwtPayload(token.idToken);
        const expiration = (payload?.exp ?? 0) * 1000;
        return expiration;
    }

    redirectToUserEditor(): void {
        const token = JSON.parse(localStorage.getItem('impersonationToken')) as ImpersonationToken;
        if (!token?.idToken) {
            this.clearImpersonationToken();
            this.redirect('/user-management/users/');
            return;
        }
        const payload = decodeJwtPayload(token.idToken);
        const userId = payload?.id;
        this.clearImpersonationToken();
        this.redirect(`/user-management/users/${userId ?? ''}`);
    }

    redirect(url: string): void {
        window.location.href = `${url}`;
    }
}
